import type { FeaturedCarousel } from '@setplex/tria-api'
import type { FeaturedChannelsCarousel } from './index.h'

import { CarouselTypes } from '@setplex/tria-api'

export const isChannelsCarousel = (
  carousel: FeaturedCarousel
): carousel is FeaturedChannelsCarousel =>
  carousel.type === CarouselTypes.TV_CHANNEL
